import React, { useState, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import LoadingSpinner from "../../atoms/loadingSpinner/LoadingSpinner";
import "./styles.styl";
import classNames from "classnames";

export default function DateSelectionList({
  dates,
  handleDateClick,
  shakeDateIndex,
  dateSelectionMessage,
  datesError,
  isLoadingUpcomingDates,
  onShakeEnd,
  deliveryDate,
  fromSubscriptionManagement = false,
}) {
  const [isUpdating, setIsUpdating] = useState(false);

  const dateInfosWithState = useMemo(() => {
    let isShaking;

    return dates.map((dateInfo, index) => {
      isShaking = index === shakeDateIndex;

      return {
        ...dateInfo,
        isShaking,
        rectangleClasses: classNames("date-list__rectangle", {
          "date-list__rectangle--selected": dateInfo.selected,
          "date-list__rectangle--disabled": dateInfo.disabled,
          "date-list__rectangle--sold": dateInfo.sold,
          "date-list__rectangle--paused": dateInfo.paused,
          "date-list__rectangle--shake": isShaking,
        }),
      };
    });
  }, [dates, shakeDateIndex, deliveryDate]);

  if (isLoadingUpcomingDates) {
    return (
      <div className="date-list">
        <LoadingSpinner
          isLoading={isLoadingUpcomingDates}
          clazzName="rule__spinner"
        />
      </div>
    );
  }

  return (
    <div className="date-list">
      {dateInfosWithState.map((dateInfo, index) => (
        <div
          key={index}
          className={dateInfo.rectangleClasses}
          onClick={() => {
            if (
              !isUpdating &&
              handleDateClick &&
              !(dateInfo.sold || dateInfo.disabled)
            ) {
              handleDateClick(dateInfo, setIsUpdating);
            }
          }}
          onAnimationEnd={() => {
            if (onShakeEnd && dateInfo.isShaking) {
              onShakeEnd();
            }
          }}
        >
          <div>{dateInfo.date}</div>
          {(dateInfo.has_inactive_timeslot ||
            dateInfo.sold ||
            dateInfo.paused ||
            !dateInfo.selected) && (
            <span className="date-list__status-label">
              {dateInfo.has_inactive_timeslot ? (
                <FormattedMessage
                  id="inactiveLabel"
                  defaultMessage="INACTIVE"
                />
              ) : dateInfo.sold ? (
                <FormattedMessage id="soldLabel" defaultMessage="SOLD" />
              ) : dateInfo.paused ||
                (fromSubscriptionManagement && !dateInfo.selected) ? (
                <FormattedMessage id="pausedLabel" defaultMessage="PAUSED" />
              ) : null}
            </span>
          )}
        </div>
      ))}

      {dateSelectionMessage && (
        <div className="date-list__info-message">{dateSelectionMessage}</div>
      )}

      {datesError && (
        <div className="date-list__error-message">{datesError}</div>
      )}
    </div>
  );
}
